import React from 'react';

import { h5 } from '../../fontSizes';
import { Container } from '../Containers';
import { PhoneNumberLink } from '../PhoneNumberLink';
import { EmailLink } from '../EmailLink';
import { smallMargin, largeMargin, mediumMargin } from '../../margins';
import { minWidth, tablet } from '../../screenSizes';
import { css } from 'emotion';
import { Button } from '../Button';
import { FacebookIcon, InstagramIcon } from '../Icons';
import { primary } from '../../colors';

const Row = (props) => (
  <div
    css={`
      width: 100%;
      text-align: center;
      margin-bottom: ${mediumMargin};

      &:last-child {
        margin-bottom: 0;
      }

      ${minWidth(tablet)} {
        width: 33%;
        margin-bottom: 0;
      }
    `}
    {...props}
  />
);
const SubRow = (props) => (
  <div
    css={`
      margin-bottom: ${smallMargin};

      &:last-child {
        margin-bottom: 0;
      }
    `}
    {...props}
  />
);
const centerLink = css`
  justify-content: center;
`;

export const Contact = ({
  address,
  postalCode,
  postalAdress,
  email,
  phoneNumber,
  allPosts,
  button: { ID: buttonPostId } = {},
}) => {
  let buttonHref = null;
  let buttonText = null;

  if (buttonPostId) {
    const buttonPost = allPosts.filter((post) => post.id === buttonPostId)[0];
    buttonHref = buttonPost.slug;
    buttonText = buttonPost.heading;
  }

  return [
    <Container
      key="contact-information"
      css={`
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        font-size: ${h5};
        margin-bottom: ${smallMargin};
      `}
    >
      <Row>
        <SubRow>{address}</SubRow>
        <SubRow>
          {postalCode} {postalAdress}
        </SubRow>
      </Row>
      <Row>
        <div
          css={`
            display: flex;
            justify-content: center;
          `}
        >
          <Button
            css={`
              display: block;
              font-size: 60px;
              color: black;
              margin: 0 calc(${smallMargin} / 2);

              &:hover,
              &:hover:focus,
              &:active:hover,
              &:focus:hover,
              &:focus:hover:active {
                color: ${primary};
                background: none;
              }

              ${minWidth(tablet)} {
                margin: 0 calc(${mediumMargin} / 2);
              }

              @media (min-width: 0) {
                // specificity hack
                padding: 0;
              }
            `}
            noBorder
            href="//www.facebook.com/Styrelsen-BarBistro-776446035757476/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Styrelsen på Facebook"
          >
            <FacebookIcon />
          </Button>
          <Button
            css={`
              display: block;
              font-size: 60px;
              color: black;
              margin: 0 calc(${smallMargin} / 2);

              &:hover,
              &:hover:focus,
              &:active:hover,
              &:focus:hover,
              &:focus:hover:active {
                color: ${primary};
                background: none;
              }

              @media (min-width: 0) {
                // specificity hack
                padding: 0;
              }
            `}
            noBorder
            href="//www.instagram.com/styrelsen_barochbistro/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Styrelsen på Instagram"
          >
            <InstagramIcon />
          </Button>
        </div>
      </Row>
      <Row>
        <SubRow>
          <PhoneNumberLink
            className={centerLink}
            iconClassName={css`
              color: initial;
            `}
            phoneNumber={phoneNumber}
          />
        </SubRow>
        <SubRow>
          <EmailLink className={centerLink} email={email} />
        </SubRow>
      </Row>
    </Container>,
    buttonHref && (
      <div
        key="contact-button-container"
        css={`
          display: flex;
          justify-content: center;

          margin-bottom: ${largeMargin};
        `}
      >
        <Button href={buttonHref}>{buttonText}</Button>
      </div>
    ),
  ];
};



// WEBPACK FOOTER //
// ./app/components/ContactSection/Contact.js